import { Component } from 'react';
import {
    Box, Button, TextField, Typography, FormControlLabel,
    Checkbox, Autocomplete, RadioGroup, Radio, Switch
} from '@mui/material';
import { withTranslation } from 'react-i18next'
import './Billings.css';
import { ImagePaths } from '../../../Utility/ImagePaths';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { CommonTimeRangePicker } from '../../../Components/Common Components/CommonComponents';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import { CurrencySymbol } from '../../../Utility/Constants';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

class BillingsFilter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            ref: props.location?.pathname,
            FilterOpen: false,
            DortorList: [],
            FilterDatas:
            {
                "FromDate": this.props.FilterDatas.FromDate,
                "ToDate": this.props.FilterDatas.ToDate,
                "DateIndex": this.props.FilterDatas.DateIndex,
                "PatientName": this.props.FilterDatas.PatientName,
                "AccNo": this.props.FilterDatas.AccNo,
                "MobNo": this.props.FilterDatas.MobNo,
                "DoctorName": this.props.FilterDatas.DoctorName,
                "BillNumber": this.props.FilterDatas.BillNumber,
                "uhidNo": this.props.FilterDatas.uhidNo,
                "PaidAmount": this.props.FilterDatas.PaidAmount,
                "InPatientSelected": this.props.FilterDatas.InPatientSelected,
                "OutPatientSelected": this.props.FilterDatas.OutPatientSelected,
                "PharmacySelected": this.props.FilterDatas.PharmacySelected,
                "LaboratorySelected": this.props.FilterDatas.LaboratorySelected,
                "ImageLabSelected": this.props.FilterDatas.ImageLabSelected,
                "OTSelected": this.props.FilterDatas.OTSelected,
                "CardSelected": this.props.FilterDatas.CardSelected,
                "CashSelected": this.props.FilterDatas.CashSelected,
                "UPISelected": this.props.FilterDatas.UPISelected,
                "BankTransferSelected": this.props.FilterDatas.BankTransferSelected,
                "InsuranceSelected": this.props.FilterDatas.InsuranceSelected,
                "ChequeSelected": this.props.FilterDatas.ChequeSelected,
                "BillType": this.props.FilterDatas.BillType,
                "PayStatus": this.props.FilterDatas.PayStatus,
                "PayMethods": this.props.FilterDatas.PayMethods,
                "CompletedSelected": this.props.FilterDatas.CompletedSelected,
                "CreditSelected": this.props.FilterDatas.CreditSelected,
                "ReturnSelected": this.props.FilterDatas.ReturnSelected,
                "CancelledSelected": this.props.FilterDatas.CancelledSelected,
                "combined":this.props.FilterDatas.combined,
                "BillStatus":this.props.FilterDatas.BillStatus,
                "BillReceiptSelected": this.props.FilterDatas.BillReceiptSelected,
                "AdvanceTypeSelected": this.props.FilterDatas.AdvanceTypeSelected,
                "AdvanceRefundTypeSelected": this.props.FilterDatas.AdvanceRefundTypeSelected,
                "RefundTypeSelected": this.props.FilterDatas.RefundTypeSelected,
                "CancelledTypeSelected":this.props.FilterDatas.CancelledTypeSelected,
                "MembershipTypeSelected":this.props.FilterDatas.MembershipTypeSelected,
                "SDTypeSelected": this.props.FilterDatas.SDTypeSelected,
                "SDRefundTypeSelected": this.props.FilterDatas.SDRefundTypeSelected,
                "RecieptType": this.props.FilterDatas.RecieptType,
                "CreditStatus":this.props.FilterDatas.CreditStatus,
                "Insurance":this.props.FilterDatas.Insurance,
                "CorporateCredit":this.props.FilterDatas.CorporateCredit,
                "PatientCredit":this.props.FilterDatas.PatientCredit,
                "startTime":this.props.FilterDatas.startTime,
                "endTime":this.props.FilterDatas.endTime,
                "UserList" : this.props.FilterDatas.UserList,
                "UserDetails" : this.props.FilterDatas.UserDetails,
                "is_user" : this.props.FilterDatas.is_user,
                'credit':this.props.FilterDatas.credit,
                'completed':this.props.FilterDatas.completed,
                'return':this.props.FilterDatas.return,
                'billType':this.props.FilterDatas.billType,
                "OPBills" : this.props.FilterDatas.OPBills,
                "IPBills" : this.props.FilterDatas.IPBills,
                "LabBills" : this.props.FilterDatas.LabBills,
                "PharmaBills" : this.props.FilterDatas.PharmaBills,
                "new_Receipt_Type" : this.props.FilterDatas.new_Receipt_Type,
                'AgainstCredit':this.props.FilterDatas?.AgainstCredit,
                'includeFObills':this.props.FilterDatas?.includeFObills ? this.props.FilterDatas?.includeFObills : false,
                "BillModuleType" : this.props.FilterDatas.BillModuleType,
                "is_bill_wise" : this.props.FilterDatas?.is_bill_wise ? this.props.FilterDatas?.is_bill_wise : false,
                "frontOfficeCrBills": this.props.FilterDatas?.frontOfficeCrBills ? this.props.FilterDatas?.frontOfficeCrBills : false,
                "opCreditBills" : this.props.FilterDatas?.opCreditBills ? this.props.FilterDatas?.opCreditBills : false,
                "ipCreditBills" : this.props.FilterDatas?.ipCreditBills ? this.props.FilterDatas?.ipCreditBills : false,
                "pharmaCreditBills" : this.props.FilterDatas?.pharmaCreditBills ? this.props.FilterDatas?.pharmaCreditBills : false,
                "labCreditBills" : this.props.FilterDatas?.labCreditBills ? this.props.FilterDatas?.labCreditBills : false,
                "RadiologySelected":this.props.FilterDatas?.RadiologySelected ? this.props.FilterDatas?.RadiologySelected : false,
                "RadiologyBills":this.props.FilterDatas?.RadiologyBills ? this.props.FilterDatas?.RadiologyBills : false,
                "radiologyCreditBills":this.props.FilterDatas?.radiologyCreditBills ? this.props.FilterDatas?.radiologyCreditBills : false,
                "doctorCreditBills":this.props.FilterDatas?.doctorCreditBills ? this.props.FilterDatas?.doctorCreditBills : false,
                "otCreditBills" : this.props.FilterDatas?.otCreditBills ? this.props.FilterDatas?.otCreditBills : false,
                "billTo": this.props.FilterDatas?.billTo,
                "billFrom": this.props.FilterDatas?.billFrom ? this.props.FilterDatas?.billFrom : '',
                "ReceiptFrom" : this.props.FilterDatas?.ReceiptFrom ? this.props.FilterDatas?.ReceiptFrom : '',
                "ReceiptTo" : this.props.FilterDatas?.ReceiptTo,
                "phoneNumber": this.props.FilterDatas?.phoneNumber,
                "patient_Name": this.props.FilterDatas?.patient_Name,
                "UHID_No": this.props.FilterDatas?.UHID_No,
                'returnFrom':this.props.FilterDatas?.returnFrom,
                'returnTo':this.props.FilterDatas?.returnTo,
                'cancelFrom':this.props.FilterDatas?.cancelFrom,
                'cancelTo':this.props.FilterDatas?.cancelTo,
                "refundNoFrom":this.props.FilterDatas?.refundNoFrom,
                "refundNoTo":this.props.FilterDatas?.refundNoTo,
                "IncludePaidBills": this.props.FilterDatas?.IncludePaidBills,
                "Bill_No": this.props.FilterDatas?.Bill_No,
                "MultiPharmaIds": this.props.FilterDatas?.MultiPharmaIds,
                "MultiLabIds": this.props.FilterDatas?.MultiLabIds,
                "MultiInvestigations": this.props.FilterDatas?.MultiInvestigations,
                'paymentStatus':this.props.FilterDatas?.paymentStatus,
                'selectedPaid':this.props.FilterDatas?.selectedPaid,
                'selectedNotPaid':this.props.FilterDatas?.selectedNotPaid,
                'selectedPartial':this.props.FilterDatas?.selectedPartial,
                'tokenNumber':this.props.FilterDatas?.tokenNumber,
                'inclusiveSD': this.props.FilterDatas?.inclusiveSD,
                'typeDoorDelivery': this.props.FilterDatas?.typeDoorDelivery,
                'typeInhouse': this.props.FilterDatas?.typeInhouse,
                "deliveryType": this.props.FilterDatas?.deliveryType,
                "insuranceName": this.props.FilterDatas?.insuranceName,
                "corporateName": this.props.FilterDatas?.corporateName,
                "insuranceData": this.props.FilterDatas?.insuranceData,
                "corporateData": this.props?.FilterDatas?.corporateData,
                "is_by_bill_no": this.props.FilterDatas?.is_by_bill_no,
                "overall_bill_no": this.props.FilterDatas?.overall_bill_no,
                "Rtselected": this.props.FilterDatas?.Rtselected,
                'single_datePicker': this.props.FilterDatas?.single_datePicker,
            },
            error:false,
            DatePickerOpen: false,
        }
    }
    componentDidMount() {
        if(this.props.callDocApi){
            this.getDoctorsList()
        }
    }

    componentDidUpdate(prevProps){
        if(this.props !== prevProps){
            this.setState({ FilterDatas: { ...this.state.FilterDatas,'UserList' :this.props.FilterDatas.UserList } })
        }
    }

    getDoctorsList = () => {
        try {
            let additionalKey = (this.props.PageName === 'OverallBills' || this.props.PageName === 'SavedBills' || this.props.PageName === 'CancelledBills') ? '?include_external_doctor=true' : ''
            if(this.props.labReceipt){

            }else{
                var Url = ""
                if( this.props.Pharmacy ){
                    Url = Serviceurls.PHARMA_DOCTOR_LIST
                }else{
                    Url = Serviceurls.FO_CONFIG_OPDOCTORNAME + additionalKey
                }
                RestAPIService.getAll(Url)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            DortorList: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }

                })
            }
        } catch (error) {
            this.errorMessage(error)
        }
    }
    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    FilterDate = (From, To, Index) => {
        this.state.FilterDatas.FromDate = From
        this.state.FilterDatas.ToDate = To
        this.state.FilterDatas.DateIndex = Index
        this.setState({ FilterDatas: this.state.FilterDatas },()=>{
            this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas:this.state.FilterDatas
            })
        })
    }

    selectedTime = (start, end,error) => {
        this.state.FilterDatas.startTime = start
        this.state.FilterDatas.endTime = end
        this.state.error = error
        this.setState({ FilterDatas: this.state.FilterDatas })
    }

    handleCheckBox = (e, key, multi = '', multiId = null) => {
        this.state.FilterDatas[key] = e.target.checked
        if(!this.state.FilterDatas.is_by_bill_no && !this.state.FilterDatas.overall_bill_no){
            this.state.FilterDatas.overall_bill_no = this.props.current_bill_sequence ||""
        }
        if(!this.state.FilterDatas.InPatientSelected){
            this.state.FilterDatas.ipCreditBills = false
        }
        if(!this.state.FilterDatas.OutPatientSelected){
            this.state.FilterDatas.opCreditBills = false
        }
        if(!this.state.FilterDatas.PharmacySelected && (!this.state.FilterDatas.InPatientSelected && !this.state.FilterDatas.OutPatientSelected)){
            this.state.FilterDatas.ipCreditBills = false
            this.state.FilterDatas.opCreditBills = false
        }
        if(!this.state.FilterDatas.LaboratorySelected && (!this.state.FilterDatas.InPatientSelected && !this.state.FilterDatas.OutPatientSelected)){
            this.state.FilterDatas.ipCreditBills = false
            this.state.FilterDatas.opCreditBills = false
        }
        if((!this.state.FilterDatas.InPatientSelected && !this.state.FilterDatas.OutPatientSelected) && localGetItem("isNewBilling") === "true"){
            this.state.FilterDatas.frontOfficeCrBills = false
            this.state.FilterDatas.radiologyCreditBills = false
        }
        if(!this.state.FilterDatas.PharmacySelected && !this.state.FilterDatas.InPatientSelected && !this.state.FilterDatas.OutPatientSelected && this.props.PageName !== 'ReceiptBills'){
            this.state.FilterDatas.pharmaCreditBills = false
            this.state.FilterDatas.MultiPharmaIds = []
        }
        if(!this.state.FilterDatas.LaboratorySelected && !this.state.FilterDatas.InPatientSelected && !this.state.FilterDatas.OutPatientSelected && this.props.PageName !== 'ReceiptBills'){
            this.state.FilterDatas.labCreditBills = false
            this.state.FilterDatas.MultiLabIds = []
        }
        if(!this.state.FilterDatas.RadiologySelected && !this.state.FilterDatas.InPatientSelected && !this.state.FilterDatas.OutPatientSelected && !this.state.FilterDatas.PharmacySelected){
            this.state.FilterDatas.radiologyCreditBills = false
        }
        if(!this.state.FilterDatas.RadiologySelected && (!this.state.FilterDatas.InPatientSelected && !this.state.FilterDatas.OutPatientSelected && !this.state.FilterDatas.PharmacySelected)){
            this.state.FilterDatas.ipCreditBills = false
            this.state.FilterDatas.opCreditBills = false
        }
        if((this.state.FilterDatas.LaboratorySelected || this.state.FilterDatas.OutPatientSelected || this.state.FilterDatas.PharmacySelected) && (!this.state.FilterDatas.OTSelected && !this.state.FilterDatas.InPatientSelected)){
            this.state.FilterDatas.otCreditBills = false
        }
        if(!this.state.FilterDatas.OTSelected){
            this.state.FilterDatas.otCreditBills = false
        }
        let MultiPharmaIds = this.state.FilterDatas.MultiPharmaIds ? this.state.FilterDatas.MultiPharmaIds : []
        if (multi === "multipharma" && (this.state.FilterDatas.OutPatientSelected || this.state.FilterDatas.InPatientSelected || this.state.FilterDatas.PharmacySelected || this.props.FromFODayEnd || this.props.FromFoReceptsBills)) {
            if (MultiPharmaIds?.includes(multiId)) {
                MultiPharmaIds = MultiPharmaIds.filter((ids) => ids !== multiId)
            } else {
                MultiPharmaIds.push(multiId)
            }
            this.state.FilterDatas.MultiPharmaIds = MultiPharmaIds
        }
        let MultiLabIds = this.state.FilterDatas.MultiLabIds ? this.state.FilterDatas.MultiLabIds : []
        if (multi === "multilab" && (this.state.FilterDatas.OutPatientSelected || this.state.FilterDatas.InPatientSelected || this.state.FilterDatas.LaboratorySelected || this.props.FromFODayEnd || this.props.FromFoReceptsBills)) {
            if (MultiLabIds?.includes(multiId)) {
                MultiLabIds = MultiLabIds.filter((ids) => ids !== multiId)
            } else {
                MultiLabIds.push(multiId)
            }
            this.state.FilterDatas.MultiLabIds = MultiLabIds
        }
        let MultiInvestigationIds = this.state.FilterDatas.MultiInvestigations ? this.state.FilterDatas.MultiInvestigations : []
        if (multi === "MultiInvestigations" && (this.state.FilterDatas.OutPatientSelected || this.state.FilterDatas.InPatientSelected || this.state.FilterDatas.LaboratorySelected || this.props.FromFODayEnd || this.props.FromFoReceptsBills)) {
            if (MultiInvestigationIds?.includes(multiId)) {
                MultiInvestigationIds = MultiInvestigationIds.filter((ids) => ids !== multiId)
            } else {
                MultiInvestigationIds.push(multiId)
            }
            this.state.FilterDatas.MultiInvestigations = MultiInvestigationIds
        }


        this.setState({ FilterDatas: this.state.FilterDatas }, () => {
            if (!this.state.FilterDatas.BillReceiptSelected) {
                this.state.FilterDatas.AgainstCredit = 'both'
                this.setState({ FilterDatas: this.state.FilterDatas })
            }
            let BillType = [];
            let BillStatus = [];
            let PayMethods = [];
            let ReceiptType = [];
            let NewReceiptType = [];
            let CreditStatus = [];
            let billTypes = [];
            let CreditBills = [];
            let paymentStatus = [];
            let deliveryType = [];
            var states = this.state
            if (states.FilterDatas.InPatientSelected) {
                BillType.push("ip")
            }
            if (states.FilterDatas.OutPatientSelected) {
                BillType.push("op")
            }
            if (states.FilterDatas.Rtselected) {
                if ((this.props.PageName === 'DayEndStatus')) {
                    BillType.push("radiotherapy")
                } else {
                    BillType.push("RT")
                }
            }
            if (this.props?.FromFoReceptsBills || this.props.FromFODayEnd) {
                if (states.FilterDatas.MultiPharmaIds?.length) {
                    BillType.push("pharmacy")
                }
                if (states.FilterDatas.MultiLabIds?.length) {
                    BillType.push('lab')
                }
            } else {
                if (states.FilterDatas.PharmacySelected) {
                    BillType.push("pharmacy")
                }
                if (states.FilterDatas.LaboratorySelected) {
                    BillType.push('lab')
                }
            }

            if (states.FilterDatas.RadiologySelected) {
                BillType.push('radiology')
            }
            if (states.FilterDatas.OTSelected) {
                BillType.push('ot')
            }
            if (states.FilterDatas.IPBills) {
                NewReceiptType.push("ip")
            }
            if (states.FilterDatas.OPBills) {
                NewReceiptType.push("op")
            }
            if (states.FilterDatas.PharmaBills) {
                NewReceiptType.push("pharmacy")
            }
            if (states.FilterDatas.LabBills) {
                NewReceiptType.push('lab')
            }
            if (states.FilterDatas.RadiologyBills) {
                NewReceiptType.push('radiology')
            }

            if (states.FilterDatas.frontOfficeCrBills) {
                CreditBills.push("fo")
            }
            if (states.FilterDatas.ipCreditBills) {
                CreditBills.push("ip")
            }
            if (states.FilterDatas.opCreditBills) {
                CreditBills.push("op")
            }
            if (states.FilterDatas.MultiPharmaIds?.length) {
                CreditBills.push("pharmacy")
            }
            if (states.FilterDatas.MultiLabIds?.length) {
                CreditBills.push('lab')
            }
            if (states.FilterDatas.radiologyCreditBills) {
                CreditBills.push('radiology')
            }
            if (states.FilterDatas.doctorCreditBills) {
                CreditBills.push('doctor')
            }
            if (states.FilterDatas.otCreditBills) {
                CreditBills.push('ot')
            }
            // if (states.FilterDatas.ImageLabSelected) {
            //     BillType.push(5)
            // }
            if (states.FilterDatas.CompletedSelected) {
                BillStatus.push("regular")
            }
            if (states.FilterDatas.CreditSelected) {
                BillStatus.push('credit')
            }
            if (states.FilterDatas.ReturnSelected) {
                BillStatus.push('return')
            }
            if (states.FilterDatas.CancelledSelected) {
                BillStatus.push('cancelled')
            }


            if (states.FilterDatas.CashSelected) {
                PayMethods.push(1)
            }
            if (states.FilterDatas.CardSelected) {
                PayMethods.push(2)
            }
            if (states.FilterDatas.UPISelected) {
                PayMethods.push(3)
            }
            if (states.FilterDatas.BankTransferSelected) {
                PayMethods.push(5)
            }
            if (states.FilterDatas.ChequeSelected) {
                PayMethods.push(4)
            }
            if (states.FilterDatas.InsuranceSelected) {
                PayMethods.push(6)
            }

            if(states.FilterDatas.BillReceiptSelected) {
                ReceiptType.push('bill')
            }
            if(states.FilterDatas.AdvanceTypeSelected && !this.props.fromLab) {
                ReceiptType.push('advance')
            }
            if(states.FilterDatas.AdvanceRefundTypeSelected && !this.props.fromLab){
                ReceiptType.push('advance refund')
            }
            if(states.FilterDatas.RefundTypeSelected){
                ReceiptType.push('refund')
            }
            if(states.FilterDatas.CorporateCredit){
                CreditStatus.push((localGetItem('isNewBilling') === "true") ?  'Corporate credit' : 'Corprate credit')
            }
            if(states.FilterDatas.PatientCredit){
                CreditStatus.push('Patient credit')
            }
            if(states.FilterDatas.Insurance){
                CreditStatus.push('Insurance credit')
            }
            if(states.FilterDatas.CancelledTypeSelected){
                ReceiptType.push('cancelled')
            }
            if(states.FilterDatas.MembershipTypeSelected){
                ReceiptType.push('membership')
            }
            if (states.FilterDatas.SDTypeSelected) {
                ReceiptType.push('safety deposit')
            }
            if (states.FilterDatas.SDRefundTypeSelected) {
                ReceiptType.push('safety deposit refund')
            }

            // if(states.FilterDatas.AgainstCredit){
            //     ReceiptType.push('against credit') 
            // }

            if(states.FilterDatas.credit){
                billTypes.push('Credit')
            }
            if(states.FilterDatas.completed){
                billTypes.push('Bill')
            }
            if(states.FilterDatas.return){
                billTypes.push('Return')
            }

            if(states.FilterDatas.selectedPaid){
                paymentStatus.push('paid')
            }
            if(states.FilterDatas.selectedNotPaid){
                paymentStatus.push('not paid')
            }
            if(states.FilterDatas.selectedPartial){
                paymentStatus.push('partial')
            }

            if(states.FilterDatas?.typeInhouse){
                deliveryType.push('inhouse')
            }
            if(states.FilterDatas?.typeDoorDelivery){
                deliveryType.push('door delivery')
            }
            
            this.state.FilterDatas.deliveryType = deliveryType
            this.state.FilterDatas.BillType = BillType
            this.state.FilterDatas.BillStatus = BillStatus
            this.state.FilterDatas.PayMethods = PayMethods
            this.state.FilterDatas.RecieptType = ReceiptType
            this.state.FilterDatas.CreditStatus = CreditStatus
            this.state.FilterDatas.combined = states.FilterDatas?.combined && PayMethods?.length >= 2 ? true : false
            this.state.FilterDatas.billType = billTypes
            this.state.FilterDatas.new_Receipt_Type = NewReceiptType
            this.state.FilterDatas.BillModuleType = CreditBills
            this.state.FilterDatas.paymentStatus = paymentStatus
            this.setState({ FilterDatas: this.state.FilterDatas })
        })
    }

    ClearFilterData() {
        let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
        let PharmacyList = LoggedData?.pharmacy_data ? JSON.parse(JSON.stringify(LoggedData?.pharmacy_data)).map((list) => list?.pharmacy_id) : []
        let LabList = LoggedData?.laboratory_data ? JSON.parse(JSON.stringify(LoggedData?.laboratory_data)).map((list) => list?.laboratory_id) : []
        let BillType =  ['op', 'ip', (localGetItem("Show_Pharmacy_Bills_In_FO") === "true") && 'pharmacy', ((localGetItem('isNewBilling') === "false") && (localGetItem("Show_Radiology_Bills_In_FO") === "true")) && 'radiology' , (localGetItem('isNewBilling') === "false") && ['lab'], "ot"].flat().filter(Boolean)
        if (LoggedData?.enable_radiotherapy) {
            BillType.push('RT');
        }
        this.setState({
            FilterDatas: {
                "FromDate": DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                "ToDate": DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                "DateIndex": 1,
                "PatientName": "",
                "AccNo": "",
                "MobNo": "",
                "DoctorName": [],
                "BillNumber": "",
                "uhidNo":"",
                "PaidAmount": "",
                "InPatientSelected": true,
                "OutPatientSelected": true,
                "PharmacySelected": localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? false : true,
                "LaboratorySelected": localGetItem("isNewBilling") === "true" ? false: true,
                "ImageLabSelected": localGetItem("isNewBilling") === "true" ? false: true,
                "OTSelected": true,
                "PaidSelected": true,
                "PartialPaidSelected": true,
                "CreditSelected": true,
                "CardSelected": true,
                "CashSelected": true,
                "UPISelected": true,
                "BankTransferSelected": true,
                "InsuranceSelected": true,
                "ChequeSelected": true,
                "BillType": BillType,
                "PayStatus": [],
                "BillStatus":["regular","credit","return"],
                "CompletedSelected": true,
                "CreditSelected": true,
                "ReturnSelected": true,
                "CancelledSelected": false,
                "PayMethods":[1,2,3,4,5,6],
                "combined":true,
                "CreditStatus":[(localGetItem('isNewBilling') === "true") ?  'Corporate credit' : 'Corprate credit', 'Insurance credit', 'Patient credit'],
                "Insurance":true,
                "PatientCredit":true,
                "CorporateCredit":true,
                "BillReceiptSelected": true,
                "AdvanceTypeSelected": true,
                "AdvanceRefundTypeSelected":true,
                "RefundTypeSelected": true,
                "CancelledTypeSelected": true,
                "MembershipTypeSelected": true,
                "SDTypeSelected": false,
                "SDRefundTypeSelected": false,
                "RecieptType": ['bill', 'advance', 'refund', 'cancelled', 'advance refund', ...(localGetItem("isNewBilling") !== "false" ? ["membership"] : []) ],
                "startTime":null,
                "endTime":null,
                "UserDetails" : [],
                "UserList" : this.props.FilterDatas.UserList,
                "is_user" : this.props.FilterDatas.is_user,
                "RecieptType": this.props.fromLab ? ['bill', 'refund', 'cancelled'] : ['bill', 'advance', 'refund', 'cancelled', 'advance refund', ...(localGetItem("isNewBilling") !== "false" ? ["membership"] : [])],
                "onError":false,
                'credit':true,
                'completed':true,
                'return':true,
                'billType':['Credit','Bill','Return'],
                "OPBills" : true,
                "IPBills" : true,
                "LabBills" : true,
                "PharmaBills" : localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? false : true,
                "new_Receipt_Type" : ['op', 'ip', 'lab', localGetItem("Show_Pharmacy_Bills_In_FO") === "true" ? 'pharmacy' : "-", localGetItem("Show_Radiology_Bills_In_FO") === "true" ? 'radiology' : "-", 'ot'],
                "AgainstCredit":'both',
                "BillModuleType": ['lab', (localGetItem("Show_Pharmacy_Bills_In_FO") === "true") && 'pharmacy', (localGetItem("Show_Radiology_Bills_In_FO") === "true") && 'radiology', (localGetItem('isNewBilling') === "false") ? ['ot' ,'op', 'ip'] : ["fo", "doctor"]].flat().filter(Boolean),
                "includeFObills" : false,
                "is_bill_wise" : (localGetItem("credit_bill_flt_config") === "bill_wise") ? true : false,
                "frontOfficeCrBills": localGetItem("isNewBilling") === "true" ? true : false,
                "opCreditBills" : localGetItem("isNewBilling") === "true" ? false: true,
                "ipCreditBills" : localGetItem("isNewBilling") === "true" ? false: true,
                "pharmaCreditBills" : localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? false : true,
                "labCreditBills" :  true,
                "RadiologyBills":localGetItem("Show_Radiology_Bills_In_FO") === "true" ? true : false,
                "RadiologySelected": (localGetItem("isNewBilling") === "false" && localGetItem("Show_Radiology_Bills_In_FO") === "true") ? true : false,
                "radiologyCreditBills":localGetItem("Show_Radiology_Bills_In_FO") === "true" ? true : false,
                "Rtselected" : true,
                "labCreditBills" : true,
                "otCreditBills" : localGetItem("isNewBilling") === "true" ? false: true,
                "billTo": "",
                "billFrom": "",
                "ReceiptFrom": '',
                "ReceiptTo": '',
                "phoneNumber": '',
                "patient_Name": '',
                "UHID_No": '',
                'returnFrom':'',
                'returnTo':'',
                'cancelFrom':'',
                'cancelTo':'',
                "refundNoFrom":"",
                "refundNoTo":"",
                "IncludePaidBills": false,
                "Bill_No": "",
                'MultiPharmaIds': localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? [] : PharmacyList,
                'MultiLabIds': LabList,
                'MultiInvestigations': localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List")) : [],
                'selectedPaid':true,
                'selectedNotPaid':true,
                'selectedPartial':true,
                'paymentStatus':['paid','not paid','partial'],
                'tokenNumber':false,
                'inclusiveSD': false,
                "doctorCreditBills": LoggedData?.is_doctor ? true : false,
                "typeDoorDelivery": true,
                "typeInhouse": true,
                "deliveryType": ["inhouse", "door delivery"],
                "is_by_bill_no": false,
                "overall_bill_no": this.props.current_bill_sequence || "",
                'single_datePicker': new Date(),
                'DatePickerOpen': false,
            }
        }, () => {
            // if (this.props.PageName === "DayEndStatus") {
                this.props.ClearData(this.state.FilterDatas)
                this.FilterSearch()
            // }
        })
    }


    closeFilter() {
        this.setState({
            FilterOpen: false
        })
    }

    FilterSearch() {
        let states = this.state
        if (this.props.PageName === "OverallBills") {
            const billNo = this.state.FilterDatas.overall_bill_no?.trim();
            if (this.props.Pharmacy && this.state.FilterDatas.is_by_bill_no
                && (billNo === this.props.current_bill_sequence ||
                    CommonValidation.numberOnly(billNo) ||
                    CommonValidation.alphabetOnly(billNo))) {

                this.errorMessage("Please Enter A Valid Bill No In Search By Bill No");
            } else if (states.FilterDatas.billTo === '' && states.FilterDatas.billFrom !== '') {
                this.errorMessage("Please Enter Bill To Number");
            } else if (states.FilterDatas.billFrom !== '' && states.FilterDatas.billTo !== '' && +states.FilterDatas.billTo < +states.FilterDatas.billFrom) {
                this.errorMessage("Bill To Number Should Greater Than Bill From Number");
            } else if (states.FilterDatas.returnFrom !== '' && states.FilterDatas.returnTo === '') {
                this.errorMessage("Please Enter Return To Number")
            } else if (states.FilterDatas.returnFrom !== '' && states.FilterDatas.returnTo !== '' && +states.FilterDatas.returnTo <= +states.FilterDatas.returnFrom) {
                this.errorMessage("Return To Number Should Greater Than Return From Number")
            } else if(states.FilterDatas.cancelTo === '' && states.FilterDatas.cancelFrom !== '' && !this.props.Pharmacy){
                this.errorMessage("Please Enter Cancel To Number")
            } else if (states.FilterDatas.cancelFrom !== '' && states.FilterDatas.cancelTo !== '' && +states.FilterDatas.cancelTo <= +states.FilterDatas.cancelFrom && !this.props.Pharmacy) {
                this.errorMessage("Bill To Number Should Greater Than Bill From Number");
            } else if(!states.FilterDatas.selectedPaid && !states.FilterDatas.selectedNotPaid && !states.FilterDatas.selectedPartial){
                this.errorMessage('Please Select Payment Status')
            }else if(!states.FilterDatas?.typeInhouse && !states.FilterDatas.typeDoorDelivery && this.props.Pharmacy){
               this.errorMessage("Please select delivery type") 
            }
             else {
                this.setState({ FilterOpen: false });
                this.props.FilteredData(this.state.FilterDatas);
            }
        } else if (this.props.PageName === "ReceiptBills") {
            if (states.FilterDatas.ReceiptFrom !== '' && states.FilterDatas.ReceiptTo === '') {
                this.errorMessage("Please Enter Receipt To Number");
            } else if (states.FilterDatas.ReceiptFrom !== '' && states.FilterDatas.ReceiptTo !== '' && +states.FilterDatas.ReceiptTo <= +states.FilterDatas.ReceiptFrom) {
                this.errorMessage("Receipt To Number Should Greater Than Receipt From Number");
            } else if(states.FilterDatas.refundNoFrom !== '' && states.FilterDatas.refundNoTo === ''){
                this.errorMessage("Please Enter Refund To Number");
            } else if(states.FilterDatas.refundNoFrom !== '' && states.FilterDatas.refundNoTo !== '' && +states.FilterDatas.refundNoTo <= +states.FilterDatas.refundNoFrom){
                this.errorMessage("Refund To Number Should Greater Than Refund From Number")
            } else if (states.FilterDatas.returnFrom !== '' && states.FilterDatas.returnTo === '') {
                this.errorMessage("Please Enter Return To Number")
            } else if (states.FilterDatas.returnFrom !== '' && states.FilterDatas.returnTo !== '' && +states.FilterDatas.returnTo <= +states.FilterDatas.returnFrom) {
                this.errorMessage("Return To Number Should Greater Than Return From Number")
            } else {
                this.setState({ FilterOpen: false });
                this.props.FilteredData(this.state.FilterDatas);
            }
        } else if ((this.props.PageName === 'DayEndStatus') || (this.props.PageName === 'LabDayEnd')){
            if (states.FilterDatas.ReceiptFrom !== '' && states.FilterDatas.ReceiptTo === '') {
                this.errorMessage("Please Enter Receipt To Number");
            } else if (states.FilterDatas.ReceiptFrom !== '' && states.FilterDatas.ReceiptTo !== '' && +states.FilterDatas.ReceiptTo <= +states.FilterDatas.ReceiptFrom) {
                this.errorMessage("Receipt To Number Should Greater Than Receipt From Number");
            }else {
                this.setState({ FilterOpen: false });
                this.props.FilteredData(this.state.FilterDatas);
            }
        }else {
            this.setState({ FilterOpen: false });
            this.props.FilteredData(this.state.FilterDatas);
        }  
    }
    PrintDetails(){
        this.setState({ FilterOpen: false })
        this.props.PrintData(this.state.FilterDatas)
    }
    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    disableSearchBtn(){
        try {
            if ((this.props.PageName === "OverallBills") || this.props?.PageName === "CancelledBills" || this.props?.PageName === "SavedBills") {
                if (this.state.FilterDatas?.BillModuleType.length === 0 || this.state.FilterDatas?.BillType.length === 0) {
                    return true
                } else {
                    return false
                }
            } else if (this.props?.PageName === "CreditBills") {
                if (this.state.FilterDatas.is_bill_wise) {
                    if ((this.state.FilterDatas?.BillModuleType.length === 0 && this.state.FilterDatas?.MultiInvestigations?.length === 0) || this.state.FilterDatas?.BillType.length === 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    if ((this.state.FilterDatas?.BillModuleType.length === 0 && this.state.FilterDatas?.MultiInvestigations?.length === 0) || this.state.FilterDatas.CreditStatus.length === 0) {
                        return true
                    } else {
                        return false
                    }
                }
            }
          else{
            return false
          }
        }catch(e){
            console.log(e?.message);
            return false
        }
    }

    CheckMappedModule(Module = "") {
        let MappedModules = localGetItem("Mapped_Module_List") ? JSON.parse(localGetItem("Mapped_Module_List")) : []
        if (Module) {
            return MappedModules?.includes(Module)
        } else {
            return true
        }
    }

    InvestigationList() {
        let List = localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List")) : []
        return List
    }

    render() {
        const { t } = this.props
        let states = this.state
        let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
        let PharmacyList = LoggedData?.pharmacy_data ? JSON.parse(JSON.stringify(LoggedData?.pharmacy_data)) : []
        let LabList = LoggedData?.laboratory_data ? JSON.parse(JSON.stringify(LoggedData?.laboratory_data)) : []
        let Admin = LoggedData?.is_super_admin 
         
        return (
            <Box component={"div"} className='eMed_Filter_Billing_Container'>
                <Box component={"div"} className='eMed_Filter_Top'>
                    <Typography variant='h6' fontWeight={"600"}>{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }, () => { this.props.CloseFilter() }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
               <Box maxHeight={'73vh'} overflow={'scroll'}>
                 <Box component={"div"} className='eMed_Filter_DateFilter'>
                    <div style={{width:"60%"}}>
                        {((this.props.PageName === "DayEndStatus") || (this.props.PageName === 'LabDayEnd') || (Admin ? (this.props.PageName === 'OverallBills' ) : null) || (Admin ? (this.props.PageName === 'CreditBills') : null) || (Admin ? (this.props.PageName === 'CancelledBills') : null) || (this.props.PageName === 'ReceiptBills' && !this.props.labReceipt)) ?
                        <Autocomplete
                        multiple
                        limitTags={1}
                        size='small'
                        options={this.state.FilterDatas?.UserList}
                        getOptionLabel={(options) => options?.user_name}
                        onChange={(e, value) => {
                            states.FilterDatas.UserDetails = value 
                            this.setState({
                                FilterDatas: states.FilterDatas
                            })
                        }}
                        disableCloseOnSelect
                        disablePortal
                        autoComplete='off'
                        value={states.FilterDatas.UserDetails}
                        id="combo-box-demo"
                        sx={{ width: "16vw" }}
                        renderInput={(params) => <TextField {...params} label={t('UserName')} size='small' />}
                    />
                        : null}
                    </div>
                    <Box style={{width:"40%", marginRight: (localGetItem('is_single_date_day_end_filter') === "true" && window.location.pathname === "/PharmacyReports/SalesDayEnd") ? "1vw" : 0}} component={"div"}>
                            {(this.props.PageName === 'ReceiptBills' && this.props.Pharmacy &&
                                (localGetItem('isNewBilling') === "true") && (localGetItem('is_single_date_day_end_filter') === "true" && window.location.pathname === "/PharmacyReports/SalesDayEnd")) ? 
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            open={this.state.DatePickerOpen}
                                            onOpen={() => { this.setState({ DatePickerOpen: true }) }}
                                            onClose={() => { this.setState({ DatePickerOpen: false }) }}
                                            value={this.state.FilterDatas.single_datePicker}
                                            name={"datePicker"}
                                            inputFormat='DD-MM-YYYY'
                                            maxDate={new Date()}
                                            views={["year", "month", "day"]}
                                            onChange={(newDate) => {
                                                this.setState((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        FilterDatas: {
                                                            ...prevState.FilterDatas,
                                                            single_datePicker: newDate?.$d ? newDate?.$d : null
                                                        }
                                                    }
                                                })
                                            }}
                                            renderInput={(params) => <TextField
                                                onKeyDown={(e) => e.preventDefault()}
                                                style={{ width: '100%' }}
                                                size='small' {...params}
                                                onClick={() => { this.setState({ DatePickerOpen: true }) }}
                                            />}
                                        />
                                    </LocalizationProvider>
                        : <CommonDatePicker
                            FromDate={this.state.FilterDatas.FromDate}
                            ToDate={this.state.FilterDatas.ToDate}
                            DateIndex={this.state.FilterDatas.DateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={this.props?.PageName !== "CreditBills"}
                            disable = {this.props.PageName === 'OverallBills' && this.props.Pharmacy && this.state.FilterDatas.is_by_bill_no} />}
                    </Box>
                </Box>
                    {(this.props.PageName === 'OverallBills' && this.props.Pharmacy) ?
                        <Box component={"div"} display={"flex"} flexDirection={"row"} alignItems={"center"}>
                            <FormControlLabel
                                sx={{ width: '2vw', marginLeft: "1vw" }}
                                control={<Checkbox
                                    sx={{ fontSize: '0.4vw' }}
                                    checked={this.state.FilterDatas.is_by_bill_no}
                                    onChange={(e) => { this.handleCheckBox(e, "is_by_bill_no") }}
                                    size='small' />}
                                label={""} />
                            <TextField
                                inputProps={{ maxLength: 30 }}
                                sx={{ width: "25vw", marginRight: "1vw" }}
                                size='small'
                                label={'Search By Bill No'}
                                value={this.state.FilterDatas.overall_bill_no}
                                disabled={!this.state.FilterDatas.is_by_bill_no}
                                autoComplete='off'
                                onChange={(e) => {
                                    let value = CommonValidation.billNo(e.target.value);
                                    if (value || e.target.value === "") {
                                        this.setState((prevState) => ({
                                            FilterDatas: {
                                                ...prevState.FilterDatas,
                                                overall_bill_no: e.target.value
                                            }
                                        }))
                                    }
                                }}
                            />
                        </Box>
                        : null}
                    {this.props.PageName === "CreditBills" ?
                        <Box sx={{display:'flex', flexDirection:'row', justifyContent:'flex-start', paddingY:'0.5vw', paddingLeft:"1vw"}}>
                            <label style={{ paddingRight: '0.8vw', paddingTop: '0.1vw' }}>Admission Wise</label>
                            <FormControlLabel
                                value="end"
                                control={
                                    <Switch
                                        size='small'
                                        color="primary"
                                        checked={this.state.FilterDatas?.is_bill_wise ? true : false}
                                        onChange={(e) => {
                                            states.FilterDatas.is_bill_wise = e.target.checked
                                            if (!states.FilterDatas.is_bill_wise) {
                                                let ModType =  localGetItem("isNewBilling") === "true"
                                                states.FilterDatas.BillModuleType = localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? (ModType ? ['fo'] : ['op','ip','lab'] ) : (ModType ? ['fo','pharmacy'] : ['op','ip','pharmacy', 'lab'] )
                                                states.FilterDatas.opCreditBills = ModType ? false : true
                                                states.FilterDatas.ipCreditBills = ModType ? false : true
                                                states.FilterDatas.frontOfficeCrBills = ModType ? true : false
                                                states.FilterDatas.pharmaCreditBills = localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? false : true
                                                states.FilterDatas.labCreditBills = true
                                                states.FilterDatas.otCreditBills = true
                                                states.FilterDatas.Bill_No = ''
                                            }
                                            this.setState({
                                                FilterDatas: states.FilterDatas
                                            })
                                        }} />}
                                label="Bill Wise"
                                labelPlacement="end"
                            />
                        </Box>
                        : null}
                {this.props.PageName !== "CreditBills" ?
                    <CommonTimeRangePicker
                        startTime={this.state.FilterDatas?.startTime}
                        endTime={this.state.FilterDatas?.endTime}
                        selectedTime={this.selectedTime.bind(this)}
                        FromDate={this.state.FilterDatas.FromDate}
                        ToDate={this.state.FilterDatas.ToDate}
                        onError={this.state.FilterDatas.onError}
                        disable={((this.props.PageName === "OverallBills" || this.props.PageName ===  "DayEndStatus" || this.props.PageName === 'LabDayEnd' || this.props.PageName === "ReceiptBills") && !this.props.Pharmacy && (this.state.FilterDatas.billFrom !== '' || this.state.FilterDatas.ReceiptFrom !== '')) ? true : false}
                        disableTimer = {(this.props.PageName === "OverallBills" && this.props.Pharmacy && this.state.FilterDatas?.is_by_bill_no)}
                    /> : null
                }
                    {((this.props.PageName === 'DayEndStatus') || (this.props.PageName === 'LabDayEnd')) ?
                        <Box sx={{ width: '100%' }}>
                            <Box component={"div"} display={"flex"} flexDirection={"row"}>
                                <TextField
                                    className="eMed_Bill_Filter_TextFeild_small"
                                    inputProps={{ maxLength: 20 }}
                                    sx={{ marginRight: '1vw', marginLeft:"1vw" }}
                                    size='small'
                                    label={`Receipt No From`}
                                    value={this.state.FilterDatas.ReceiptFrom}
                                    disabled={(this.state.FilterDatas.startTime !== '' && this.state.FilterDatas.startTime != null) ? true : false}
                                    autoComplete='off'
                                    onChange={(e) => {
                                        let value = CommonValidation.billNo(e.target.value);
                                        if (value || e.target.value === "") {
                                            this.state.FilterDatas.ReceiptFrom = e.target.value
                                            this.setState({ FilterDatas: this.state.FilterDatas })
                                        }
                                    }}
                                />
                                <TextField
                                    inputProps={{ maxLength: 20 }}
                                    className="eMed_Bill_Filter_TextFeild_small"
                                    size='small'
                                    label={`Receipt No To`}
                                    value={this.state.FilterDatas.ReceiptTo}
                                    disabled={!this.state.FilterDatas.ReceiptFrom}
                                    autoComplete='off'
                                    onChange={(e) => {
                                        let value = CommonValidation.billNo(e.target.value);
                                        if (value || e.target.value === "") {
                                            this.state.FilterDatas.ReceiptTo = e.target.value
                                            this.setState({ FilterDatas: this.state.FilterDatas })
                                        }
                                    }}
                                />
                            </Box>
                            {(this.props.PageName === 'DayEndStatus' && localGetItem("enable_safety_deposit") === "true" && localGetItem("safety_deposit_permission") === "true") ?
                                <FormControlLabel sx={{ width: '20vw', marginLeft:"1vw" }} control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.FilterDatas.inclusiveSD} onChange={(e) => { this.handleCheckBox(e, "inclusiveSD",) }} size='small' />} label={t("Inclusive of Safety Deposit")} />
                                : null}
                        </Box>
                        : null}

                {
                    this.props.PageName !== "DayEndStatus" &&  this.props.PageName !== "LabDayEnd" && this.props.PageName !== "CreditBills" ?
                        <Box component={'div'}>
                            <Box component={"div"} className='eMed_Filter_TextFields'>
                                <Box component={'div'} display="flex" flexDirection={"row"} justifyContent={"space-between"} width={"100%"}>
                                    <TextField
                                        inputProps={{ maxLength: 30 }}
                                        className="eMed_Bill_Filter_TextFeild_small"
                                        size='small'
                                        label={t("PatientName")}
                                        disabled = {this.props.PageName === "OverallBills" && this.props.Pharmacy && this.state.FilterDatas?.is_by_bill_no}
                                        name={"FilterKey"}
                                        value={this.state.FilterDatas.PatientName}
                                        autoComplete='off'
                                        onChange={(e) => {
                                            let number = CommonValidation.alphabetOnly(e.target.value);
                                            if (number || e.target.value === "") {
                                                this.state.FilterDatas.PatientName = e.target.value
                                                this.setState({ FilterDatas: this.state.FilterDatas })
                                            }

                                        }}
                                    />
                                    {this.props.PageName != "ReceiptBills" ?
                                        <TextField
                                            inputProps={{ maxLength: 13 }}
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            size='small'
                                            label={t("UHID")}
                                            disabled = {this.props.PageName === "OverallBills" && this.props.Pharmacy && this.state.FilterDatas?.is_by_bill_no}
                                            name={"FilterKey"}
                                            value={this.state.FilterDatas.AccNo}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let number = CommonValidation.gstnumberValidation(e.target.value);
                                                if (number || e.target.value === "") {
                                                    this.state.FilterDatas.AccNo = e.target.value.toUpperCase()
                                                    this.setState({ FilterDatas: this.state.FilterDatas })
                                                }
                                            }}
                                        />
                                        : this.props.labReceipt || !this.props.Pharmacy ? <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            inputProps={{ maxLength: 13 }}
                                            size='small'
                                            label={this.props.labReceipt || !this.props.Pharmacy ? t('RNo') : t("BillNumber")}
                                            value={this.state.FilterDatas.BillNumber}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                                if (number || e.target.value === "") {
                                                    this.state.FilterDatas.BillNumber = e.target.value.toUpperCase()
                                                    this.setState({ FilterDatas: this.state.FilterDatas })
                                                }
                                            }}
                                        /> : <TextField
                                        inputProps={{ maxLength: 20 }}
                                        className="eMed_Bill_Filter_TextFeild_small"
                                        size='small'
                                        label={this.props.PageName === 'ReceiptBills' ? t(`Amount${CurrencySymbol}`) : t('PaidAmount')+`(${CurrencySymbol})`}
                                        value={this.state.FilterDatas.PaidAmount}
                                        autoComplete='off'
                                        onChange={(e) => {
                                            let number = CommonValidation.NumberWithDot(e.target.value);
                                            if (number || e.target.value === "") {
                                                this.state.FilterDatas.PaidAmount = e.target.value
                                                this.setState({ FilterDatas: this.state.FilterDatas })
                                            }
                                        }
                                        }
                                    />}
                                </Box>
                                {this.props.PageName != "ReceiptBills" ?
                                    <Box component={'div'} display="flex" flexDirection={"row"} justifyContent={"space-between"} width={"100%"}>
                                        <TextField
                                            inputProps={{ maxLength: 10 }}
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            size='small'
                                            label={t("MobNo")}
                                            name={"FilterKey"}
                                            value={this.state.FilterDatas.MobNo}
                                            disabled = {this.props.PageName === "OverallBills" && this.props.Pharmacy && this.state.FilterDatas?.is_by_bill_no}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let number = CommonValidation.numberOnly(e.target.value);
                                                if (number || e.target.value === "") {
                                                    this.state.FilterDatas.MobNo = e.target.value
                                                    this.setState({ FilterDatas: this.state.FilterDatas })
                                                }
                                            }}
                                        />
                                        <Box  className='eMed_Dropdown'>
                                        <Autocomplete
                                            multiple
                                            limitTags={1}
                                            size='small'
                                            options={this.state.DortorList?.map((item) => item)}
                                            getOptionLabel={(option) => (this.props.Pharmacy ? option?.name : (option?.doctor_name || option?.name))}
                                            value={this.state.FilterDatas?.DoctorName}
                                            onChange={(event, newValue) => {
                                                this.state.FilterDatas.DoctorName = newValue
                                                this.setState({
                                                    FilterDatas:this.state.FilterDatas
                                                })
                                            }}
                                            disabled = {this.props.PageName === "OverallBills" && this.props.Pharmacy && this.state.FilterDatas?.is_by_bill_no}
                                            autoComplete='off'
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t('selectDoctor')}
                                                />
                                                    )}
                                                    renderOption={(props, option) => (
                                                        option?.external_doctor ? (
                                                            <li
                                                                {...props}
                                                                key={option?.doctor_id}
                                                                style={{
                                                                    backgroundColor: '#edd8d8ff'
                                                                }}
                                                            >
                                                                <li {...props} key={this.props.Pharmacy ? option?.id : option?.doctor_id}>
                                                                    {this.props.Pharmacy ? option?.name : (option?.doctor_name || option?.name)}
                                                                </li>
                                                            </li>
                                                        ) : (
                                                            <li {...props} key={this.props.Pharmacy ? option?.id : option?.doctor_id}>
                                                                {this.props.Pharmacy ? option?.name : (option?.doctor_name || option?.name)}
                                                            </li>
                                                        )
                                                    )}
                                        />
                                        </Box>
                                        {/* <FormControl size='small' className='eMed_Dropdown'>
                                            <InputLabel>{t("SelectDoctor")}</InputLabel>
                                            <Select
                                                value={this.state.FilterDatas.DoctorName}
                                                label={t("SelectDoctor")}
                                                onChange={(e) => {
                                                    this.state.FilterDatas.DoctorName = e.target.value
                                                    this.setState({ FilterDatas: this.state.FilterDatas })
                                                }}
                                            >
                                                <MenuItem value={""}>All</MenuItem>
                                                {
                                                    this.state.DortorList?.length > 0 ?
                                                        this.state.DortorList.map((list, index) => (
                                                            <MenuItem key={index} value={list.doctor_name}>{list.doctor_name}</MenuItem>
                                                        )) : null
                                                }
                                            </Select>
                                        </FormControl> */}
                                    </Box> : null}
                                {this.props.PageName != 'ReceiptBills' && this.props.PageName != 'OverallBills' ?
                                    <Box component={"div"} display={"flex"} flexDirection={"row"}>
                                        <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            inputProps={{ maxLength: 20 }}
                                            sx={{ marginRight: '1vw' }}
                                            size='small'
                                            label={t("BillNumber")}
                                            value={this.state.FilterDatas.BillNumber}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                                if (number || e.target.value === "") {
                                                    this.state.FilterDatas.BillNumber = e.target.value.toUpperCase()
                                                    this.setState({ FilterDatas: this.state.FilterDatas })
                                                }
                                            }}
                                        />
                                        {/* <TextField
                                            inputProps={{ maxLength: 10 }}
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            size='small'
                                            label={t("PaidAmount₹")}
                                            value={this.state.FilterDatas.PaidAmount}
                                            onChange={(e) => {
                                                let number = CommonValidation.NumberWithDot(e.target.value);
                                                if (number || e.target.value === "") {
                                                    this.state.FilterDatas.PaidAmount = e.target.value
                                                    this.setState({ FilterDatas: this.state.FilterDatas })
                                                }
                                            }
                                            }
                                        /> */}
                                    </Box> : null}
                                    {this.props.PageName === 'OverallBills' ?
                                    <Box component={"div"} display={"flex"} flexDirection={"row"}>
                                        <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            inputProps={{ maxLength: 20 }}
                                            sx={{ marginRight: '1vw' }}
                                            size='small'
                                            name={'billFrom'}
                                            label={"Bill No From"}
                                            value={this.state.FilterDatas.billFrom}
                                            disabled={(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy) ? true : (this.state.FilterDatas.startTime !== '' && this.state.FilterDatas.startTime != null && !this.props.Pharmacy) ? true : false}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let value = e.target.value
                                                // if(this.props.Pharmacy){
                                                    if (CommonValidation.numberOnly(value) || value === '') {
                                                        this.state.FilterDatas['billFrom'] = value
                                                        this.setState({
                                                            FilterDatas: this.state.FilterDatas
                                                        })
                                                    }
                                                // }else{
                                                //     if (CommonValidation.billNo(value) || value === '') {
                                                //         this.state.FilterDatas['billFrom'] = value
                                                //         this.setState({
                                                //             FilterDatas: this.state.FilterDatas
                                                //         })
                                                //     }
                                                // }
                                            }}
                                        />
                                        <TextField
                                            inputProps={{ maxLength: 20 }}
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            size='small'
                                            name={'billTo'}
                                            label={"Bill No To"}
                                            value={this.state.FilterDatas.billTo}
                                            disabled={(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy) ? true : !this.state.FilterDatas.billFrom}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                // if(this.props.Pharmacy){
                                                    if (CommonValidation.numberOnly(value) || value === '') {
                                                        this.state.FilterDatas['billTo'] = value
                                                        this.setState({
                                                            FilterDatas: this.state.FilterDatas
                                                        })
                                                    }
                                                // }else{ 
                                                //     if (CommonValidation.billNo(value) || value === '') {
                                                //         this.state.FilterDatas['billTo'] = value
                                                //         this.setState({
                                                //             FilterDatas: this.state.FilterDatas
                                                //         })
                                                //     }
                                                // }
                                            }
                                            }
                                        />
                                    </Box> : null}
                                    {/* Commented for this Filter Not Needed */}
                                    {/* {this.props.PageName === 'OverallBills' ?
                                    <Box component={"div"} display={"flex"} flexDirection={"row"}>
                                        <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            inputProps={{ maxLength: 20 }}
                                            sx={{ marginRight: '1vw' }}
                                            size='small'
                                            name={'returnFrom'}
                                            label={"Return No From"}
                                            value={this.state.FilterDatas.returnFrom}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (CommonValidation.numberOnly(value) || value === '') {
                                                    this.state.FilterDatas['returnFrom'] = value
                                                    this.setState({
                                                        FilterDatas: this.state.FilterDatas
                                                    })
                                                }
                                            }}
                                        />
                                        <TextField
                                            inputProps={{ maxLength: 10 }}
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            size='small'
                                            name={'returnNo'}
                                            label={"Return No To"}
                                            value={this.state.FilterDatas.returnTo}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (CommonValidation.numberOnly(value) || value === '') {
                                                    this.state.FilterDatas['returnTo'] = value
                                                    this.setState({
                                                        FilterDatas: this.state.FilterDatas
                                                    })
                                                }
                                            }
                                            }
                                        />
                                    </Box> : null}
                                    {this.props.PageName === 'OverallBills' && !this.props.Pharmacy ?
                                    <Box component={"div"} display={"flex"} flexDirection={"row"}>
                                        <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            inputProps={{ maxLength: 20 }}
                                            sx={{ marginRight: '1vw' }}
                                            size='small'
                                            name={'cancelFrom'}
                                            label={"Cancel No From"}
                                            value={this.state.FilterDatas.cancelFrom}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (CommonValidation.numberOnly(value) || value === '') {
                                                    this.state.FilterDatas['cancelFrom'] = value
                                                    this.setState({
                                                        FilterDatas: this.state.FilterDatas
                                                    })
                                                }
                                            }}
                                        />
                                        <TextField
                                            inputProps={{ maxLength: 10 }}
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            size='small'
                                            name={'cancelTo'}
                                            label={"Cancel No To"}
                                            value={this.state.FilterDatas.cancelTo}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (CommonValidation.numberOnly(value) || value === '') {
                                                    this.state.FilterDatas['cancelTo'] = value
                                                    this.setState({
                                                        FilterDatas: this.state.FilterDatas
                                                    })
                                                }
                                            }
                                            }
                                        />
                                    </Box> : null} */}

                            </Box>
                            {this.props.PageName === 'ReceiptBills' && !this.props.Pharmacy ?
                                    <Box>
                                        <Box component={"div"} display={"flex"} flexDirection={"row"} marginLeft={'1vw'}>
                                            <TextField
                                                className="eMed_Bill_Filter_TextFeild_small"
                                                inputProps={{ maxLength: 20 }}
                                                sx={{ marginRight: '0.7vw' }}
                                                size='small'
                                                disabled={(this.state.FilterDatas.startTime !== '' && this.state.FilterDatas.startTime != null ) ? true : false}
                                                label={`Receipt No From`}
                                                value={this.state.FilterDatas.ReceiptFrom}
                                                autoComplete='off'
                                                onChange={(e) => {
                                                    let value = CommonValidation.billNo(e.target.value);
                                                    if (value || e.target.value === "") {
                                                        this.state.FilterDatas.ReceiptFrom = e.target.value
                                                        this.setState({ FilterDatas: this.state.FilterDatas })
                                                    }
                                                }}
                                            />
                                            <TextField
                                                inputProps={{ maxLength: 20 }}
                                                className="eMed_Bill_Filter_TextFeild_small"
                                                size='small'
                                                label={`Receipt No To`}
                                                value={this.state.FilterDatas.ReceiptTo}
                                                disabled={!this.state.FilterDatas.ReceiptFrom}
                                                autoComplete='off'
                                                onChange={(e) => {
                                                    let value = CommonValidation.billNo(e.target.value);
                                                    if (value || e.target.value === "") {
                                                        this.state.FilterDatas.ReceiptTo = e.target.value
                                                        this.setState({ FilterDatas: this.state.FilterDatas })
                                                    }
                                                }}
                                            />
                                        </Box>
                                        <Box component={"div"} display={"flex"} flexDirection={"row"} marginLeft={'1vw'}>
                                            <TextField
                                                inputProps={{ maxLength: 20 }}
                                                className="eMed_Bill_Filter_TextFeild_small"
                                                size='small'
                                                label={this.props.PageName === 'ReceiptBills' ? t(`Amount${CurrencySymbol}`) : t('PaidAmount')+`(${CurrencySymbol})`}
                                                value={this.state.FilterDatas.PaidAmount}
                                                autoComplete='off'
                                                onChange={(e) => {
                                                    let number = CommonValidation.NumberWithDot(e.target.value);
                                                    if (number || e.target.value === "") {
                                                        this.state.FilterDatas.PaidAmount = e.target.value
                                                        this.setState({ FilterDatas: this.state.FilterDatas })
                                                    }
                                                }
                                                }
                                            />
                                            {this.props.labReceipt ?
                                                <TextField
                                                    className="eMed_Bill_Filter_TextFeild_small"
                                                    inputProps={{ maxLength: 10 }}
                                                    size='small'
                                                    sx={{ marginLeft: '1vw' }}
                                                    label={t('UHID')}
                                                    value={this.state.FilterDatas.uhidNo}
                                                    autoComplete='off'
                                                    onChange={(e) => {
                                                        let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                                        if (number || e.target.value === "") {
                                                            this.state.FilterDatas.uhidNo = e.target.value.toUpperCase()
                                                            this.setState({ FilterDatas: this.state.FilterDatas })
                                                        }
                                                    }}
                                                />: null}
                                        </Box>
                                    </Box> : null
                            }
                            {this.props.PageName === 'ReceiptBills' && this.props.Pharmacy ?
                                <Box component={"div"} display={"flex"} flexDirection={"row"} marginLeft={'1vw'}>
                                    <TextField
                                        inputProps={{ maxLength: 20 }}
                                        className="eMed_Bill_Filter_TextFeild_small"
                                        size='small'
                                        label={`Receipt No From`}
                                        value={this.state.FilterDatas.ReceiptFrom}
                                        autoComplete='off'
                                        onChange={(e) => {
                                            let number = CommonValidation.numberOnly(e.target.value);
                                            if (number || e.target.value === "") {
                                                this.state.FilterDatas.ReceiptFrom = e.target.value
                                                this.setState({ FilterDatas: this.state.FilterDatas })
                                            }
                                        }
                                        }
                                    /> 
                                    <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            inputProps={{ maxLength: 20 }}
                                            size='small'
                                            sx={{ marginLeft: '1vw' }}
                                            label={`Receipt No To`}
                                            value={this.state.FilterDatas.ReceiptTo}
                                            disabled={!this.state.FilterDatas.ReceiptFrom}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let number = CommonValidation.numberOnly(e.target.value);
                                                if (number || e.target.value === "") {
                                                    this.state.FilterDatas.ReceiptTo = e.target.value.toUpperCase()
                                                    this.setState({ FilterDatas: this.state.FilterDatas },() => {
                                                        if ((this.state.FilterDatas.ReceiptTo === '' && this.state.FilterDatas?.returnTo === '') || (this.state.FilterDatas.ReceiptTo !== '' && this.state.FilterDatas?.returnTo !== '')) {
                                                            this.state.FilterDatas.RefundTypeSelected = true
                                                            this.state.FilterDatas.BillReceiptSelected = true
                                                            this.state.FilterDatas.RecieptType = ['bill', 'advance', 'refund', 'cancelled', 'advance refund', ...(localGetItem("isNewBilling") !== "false" ? ["membership"] : [])]
                                                            this.setState({ FilterDatas: this.state.FilterDatas })
                                                        } else if((this.state.FilterDatas.ReceiptTo !== '' && this.state.FilterDatas?.returnTo === '')) {
                                                            this.state.FilterDatas.RefundTypeSelected = false
                                                            this.state.FilterDatas.BillReceiptSelected = true
                                                            this.state.FilterDatas.RecieptType = ['bill', 'advance', 'cancelled', 'advance refund', ...(localGetItem("isNewBilling") !== "false" ? ["membership"] : [])]
                                                            this.setState({ FilterDatas: this.state.FilterDatas })
                                                        } else if(this.state.FilterDatas.ReceiptTo === '' && this.state.FilterDatas?.returnTo !== ''){
                                                            this.state.FilterDatas.RefundTypeSelected = true
                                                            this.state.FilterDatas.BillReceiptSelected = false
                                                            this.state.FilterDatas.RecieptType = ['advance', 'refund', 'cancelled', 'advance refund', ...(localGetItem("isNewBilling") !== "false" ? ["membership"] : [])]
                                                            this.setState({ FilterDatas: this.state.FilterDatas })
                                                        }
                                                    })
                                                }
                                            }}
                                        />
                                </Box> : null
                            }
                            {this.props.PageName === 'ReceiptBills' && this.props.Pharmacy ?
                                <Box component={"div"} display={"flex"} flexDirection={"row"} marginLeft={'1vw'}>
                                    <TextField
                                        inputProps={{ maxLength: 20 }}
                                        className="eMed_Bill_Filter_TextFeild_small"
                                        size='small'
                                        label={`Return No From`}
                                        value={this.state.FilterDatas.returnFrom}
                                        autoComplete='off'
                                        onChange={(e) => {
                                            let number = CommonValidation.numberOnly(e.target.value);
                                            if (number || e.target.value === "") {
                                                this.state.FilterDatas.returnFrom = e.target.value
                                                this.setState({ FilterDatas: this.state.FilterDatas })
                                            }
                                        }
                                        }
                                    /> 
                                    <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            inputProps={{ maxLength: 20 }}
                                            size='small'
                                            sx={{ marginLeft: '1vw' }}
                                            label={`Return No To`}
                                            value={this.state.FilterDatas.returnTo}
                                            disabled={!this.state.FilterDatas.returnFrom}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let number = CommonValidation.numberOnly(e.target.value);
                                                if (number || e.target.value === "") {
                                                    this.state.FilterDatas.returnTo = e.target.value.toUpperCase()
                                                    this.setState({ FilterDatas: this.state.FilterDatas },() => {
                                                        if ((this.state.FilterDatas.ReceiptTo === '' && this.state.FilterDatas?.returnTo === '') || (this.state.FilterDatas.ReceiptTo !== '' && this.state.FilterDatas?.returnTo !== '')) {
                                                            this.state.FilterDatas.RefundTypeSelected = true
                                                            this.state.FilterDatas.BillReceiptSelected = true
                                                            this.state.FilterDatas.RecieptType = ['bill', 'advance', 'refund', 'cancelled', 'advance refund', ...(localGetItem("isNewBilling") !== "false" ? ["membership"] : [])]
                                                            this.setState({ FilterDatas: this.state.FilterDatas })
                                                        } else if((this.state.FilterDatas.returnTo !== '' && this.state.FilterDatas?.ReceiptTo === '')) {
                                                            this.state.FilterDatas.RefundTypeSelected = true
                                                            this.state.FilterDatas.BillReceiptSelected = false
                                                            this.state.FilterDatas.RecieptType = ['advance', 'refund', 'cancelled', 'advance refund', ...(localGetItem("isNewBilling") !== "false" ? ["membership"] : [])]
                                                            this.setState({ FilterDatas: this.state.FilterDatas })
                                                        } else if(this.state.FilterDatas.returnTo === '' && this.state.FilterDatas?.ReceiptTo !== ''){
                                                            this.state.FilterDatas.RefundTypeSelected = false
                                                            this.state.FilterDatas.BillReceiptSelected = true
                                                            this.state.FilterDatas.RecieptType = ['bill', 'advance', 'cancelled', 'advance refund', ...(localGetItem("isNewBilling") !== "false" ? ["membership"] : [])]
                                                            this.setState({ FilterDatas: this.state.FilterDatas })
                                                        }
                                                    })
                                                }
                                            }}
                                        />
                                </Box> : null
                            }
                        </Box> : 
                        this.props.PageName === 'CreditBills' ?
                                <Box>
                                    <Box component={"div"} display={"flex"} flexDirection={"row"} marginLeft={'1vw'}>
                                        <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            size='small'
                                            label={t('Patient Name')}
                                            value={this.state.FilterDatas.patient_Name}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                                if (number || e.target.value === "") {
                                                    this.state.FilterDatas.patient_Name = e.target.value.toUpperCase()
                                                    this.setState({ FilterDatas: this.state.FilterDatas })
                                                }
                                            }}
                                        />
                                        <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            size='small'
                                            sx={{ marginLeft: '1vw' }}
                                            label={`UHID`}
                                            value={this.state.FilterDatas.UHID_No}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                                if (number || e.target.value === "") {
                                                    this.state.FilterDatas.UHID_No = e.target.value
                                                    this.setState({ FilterDatas: this.state.FilterDatas })
                                                }
                                            }
                                            }
                                        />
                                    </Box>
                                    <Box component={"div"} display={"flex"} flexDirection={"row"} marginLeft={'1vw'}>
                                    <TextField
                                            className="eMed_Bill_Filter_TextFeild_small"
                                            size='small'
                                            label={`Mobile No`}
                                            value={this.state.FilterDatas.phoneNumber}
                                            autoComplete='off'
                                            onChange={(e) => {
                                                let number = CommonValidation.numberOnly(e.target.value);
                                                if ((number && e.target.value.length < 11) || e.target.value === "") {
                                                    this.state.FilterDatas.phoneNumber = e.target.value
                                                    this.setState({ FilterDatas: this.state.FilterDatas })
                                                }
                                            }
                                            }
                                        />
                                        {this.state.FilterDatas?.is_bill_wise ?
                                            <TextField
                                                className="eMed_Bill_Filter_TextFeild_small"
                                                size='small'
                                                sx={{ marginLeft: '1vw' }}
                                                label={t("BillNumber")}
                                                value={this.state.FilterDatas.Bill_No}
                                                autoComplete='off'
                                                onChange={(e) => {
                                                    let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                                    if (number || e.target.value === "") {
                                                        this.state.FilterDatas.Bill_No = e.target.value.toUpperCase()
                                                        this.setState({ FilterDatas: this.state.FilterDatas })
                                                    }
                                                }}
                                            /> : null}
                                    </Box>
                                </Box>
                        
                         : null
                    
                }
                {this.props.PageName === 'ReceiptBills' && !this.props?.Pharmacy && !this.props?.labReceipt ?
                <Box component={"div"}>
                    <Box className="eMed_Filter_Header">
                        <Typography marginLeft={"1vw"}>{t("Bill Type")}</Typography>
                    </Box>
                    <Box className="eMed_CheckBox_Group">
                        <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.FilterDatas.IPBills} onChange={(e) => { this.handleCheckBox(e, "IPBills",) }} size='small' />} label={t("InPatient")} />
                        <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.OPBills} onChange={(e) => { this.handleCheckBox(e, "OPBills") }} size='small' />} label={t("OutPatient")} />
                        {this.CheckMappedModule("PHARMACY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Pharmacy_Bills_In_FO") === "false"} checked={this.state.FilterDatas.PharmaBills} onChange={(e) => { this.handleCheckBox(e, "PharmaBills") }} size='small' />} label={t("Pharmacy")} /> : null }
                        {this.CheckMappedModule("LAB") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.LabBills} onChange={(e) => { this.handleCheckBox(e, "LabBills") }} size='small' />} label={t("Laboratory")} /> : null}
                        {this.CheckMappedModule("RADIOLOGY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem('Show_Radiology_Bills_In_FO') === 'false'} checked={this.state.FilterDatas.RadiologyBills} onChange={(e) => { this.handleCheckBox(e, "RadiologyBills") }} size='small' />} label={t("Radiology")} /> : null }
                        {this.CheckMappedModule("RADIOTHERAPY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.Rtselected} onChange={(e) => { this.handleCheckBox(e, "Rtselected") }} size='small' />} label={t("Radiotherapy")} /> : null }
                        {this.InvestigationList()?.length > 0 &&
                                    <>
                                        {this.InvestigationList()?.map((list, index) => (
                                            <FormControlLabel key={index} className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas?.MultiInvestigations?.includes(list)} onChange={(e) => { this.handleCheckBox(e, "investigationCreditBills", "MultiInvestigations", list) }} size='small' />} label={list} />
                                        ))}
                                    </>
                        }
                        {/* <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.ImageLabSelected} onChange={(e) => { this.handleCheckBox(e, "ImageLabSelected") }} size='small' />} label={t("ImageLab")} />
                        <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.OTSelected} onChange={(e) => { this.handleCheckBox(e, "OTSelected") }} size='small' />} label={t("OT")} /> */}
                        {/* <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.ImageLabSelected} onChange={(e) => { this.handleCheckBox(e, "ImageLabSelected") }} size='small' />} label={t("ImageLab")} />*/}
                        {this.props?.PageName === "CancelledBills" || this.props?.PageName === "SavedBills" || this.props.PageName === 'ReceiptBills' ||!this.CheckMappedModule("OT") ? null : <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.OTSelected} onChange={(e) => { this.handleCheckBox(e, "OTSelected") }} size='small' />} label={t("OT")} />} 
                    </Box>
                </Box> : null}
                {this.props.PageName === 'CreditBills' && !this.props?.Pharmacy ?
                <Box component={"div"}>
                    <Box className="eMed_CheckBox_Group">
                        <FormControlLabel sx={{width: '12vw'}} control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.FilterDatas.IncludePaidBills} onChange={(e) => { this.handleCheckBox(e, "IncludePaidBills",) }} size='small' />} label={t("Include Paid Bills")} />
                        </Box>
                </Box> : null}
                { localGetItem("isNewBilling") === "true" ?
                <>{this.props.labReceipt || this.props.Pharmacy || this.props.PageName === 'LabDayEnd' ? null : 
                <Box component={"div"}>
                    <Box className="eMed_Filter_Header">
                        <Typography marginLeft={"1vw"}>{this.props.PageName === 'ReceiptBills' ? t("Paid In") : t("ModuleType")}</Typography>
                    </Box>
                    <Box className="eMed_CheckBox_Group">
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.FilterDatas.InPatientSelected} onChange={(e) => { this.handleCheckBox(e, "InPatientSelected",) }} size='small' />} label={t("InPatient")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.OutPatientSelected} onChange={(e) => { this.handleCheckBox(e, "OutPatientSelected") }} size='small' />} label={t("OutPatient")} />
                                {(this.CheckMappedModule("RADIOTHERAPY") && this.props.PageName !== 'ReceiptBills') ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.Rtselected} onChange={(e) => { this.handleCheckBox(e, "Rtselected") }} size='small' />} label={t("Radiotherapy")} /> : null}
                                {(this.props.FromFoReceptsBills || this.props?.FromFODayEnd) ?
                                    <>
                                        {this.CheckMappedModule("PHARMACY") && PharmacyList?.map((list, index) => (
                                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Pharmacy_Bills_In_FO") === "false"} checked={this.state.FilterDatas?.MultiPharmaIds?.includes(list?.pharmacy_id)} onChange={(e) => { this.handleCheckBox(e, "PharmacySelected", "multipharma", list?.pharmacy_id) }} size='small' />} label={PharmacyList?.length > 1 ? list?.pharmacy_name : t("Pharmacy")} />
                                        ))
                                        }
                                    </> :
                                    <>
                                        {this.CheckMappedModule("PHARMACY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Pharmacy_Bills_In_FO") === "false"} checked={this.state.FilterDatas.PharmacySelected} onChange={(e) => { this.handleCheckBox(e, "PharmacySelected") }} size='small' />} label={t("Pharmacy")} /> : null}
                                    </>
                                }
                    </Box>
                </Box>}</>
                :
                <>{this.props.labReceipt || this.props.Pharmacy || this.props.PageName === 'LabDayEnd' ? null : 
                <Box component={"div"}>
                    <Box className="eMed_Filter_Header">
                        <Typography marginLeft={"1vw"}>{this.props.PageName === 'ReceiptBills' ? t("Paid In") : t("ModuleType")}</Typography>
                    </Box>
                    <Box className="eMed_CheckBox_Group">
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.FilterDatas.InPatientSelected} onChange={(e) => { this.handleCheckBox(e, "InPatientSelected",) }} size='small' />} label={t("InPatient")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.OutPatientSelected} onChange={(e) => { this.handleCheckBox(e, "OutPatientSelected") }} size='small' />} label={t("OutPatient")} />
                                {(this.props.FromFoReceptsBills || this.props?.FromFODayEnd) ?
                                    <>
                                        {this.CheckMappedModule("PHARMACY") && PharmacyList?.map((list, index) => (
                                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Pharmacy_Bills_In_FO") === "false"} checked={this.state.FilterDatas?.MultiPharmaIds?.includes(list?.pharmacy_id)} onChange={(e) => { this.handleCheckBox(e, "PharmacySelected", "multipharma", list?.pharmacy_id) }} size='small' />} label={PharmacyList?.length > 1 ? list?.pharmacy_name : t("Pharmacy")} />
                                        ))
                                        }

                                        {this.CheckMappedModule("LAB") && LabList?.map((list, index) => (
                                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas?.MultiLabIds?.includes(list?.laboratory_id)} onChange={(e) => { this.handleCheckBox(e, "LaboratorySelected", "multilab", list?.laboratory_id) }} size='small' />} label={LabList?.length > 1 ? list?.laboratory_name : t("Laboratory")} />
                                        ))
                                        }
                                    </> :
                                    <>
                                        {this.CheckMappedModule("PHARMACY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Pharmacy_Bills_In_FO") === "false"} checked={this.state.FilterDatas.PharmacySelected} onChange={(e) => { this.handleCheckBox(e, "PharmacySelected") }} size='small' />} label={t("Pharmacy")} /> : null}
                                        {this.CheckMappedModule("LAB") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.LaboratorySelected} onChange={(e) => { this.handleCheckBox(e, "LaboratorySelected") }} size='small' />} label={t("Laboratory")} /> : null}
                                    </>
                                }
                                {this.CheckMappedModule("RADIOLOGY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Radiology_Bills_In_FO") === "false"} checked={this.state.FilterDatas.RadiologySelected} onChange={(e) => { this.handleCheckBox(e, "RadiologySelected") }} size='small' />} label={t("Radiology")} /> : null}
                                {/* <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.ImageLabSelected} onChange={(e) => { this.handleCheckBox(e, "ImageLabSelected") }} size='small' />} label={t("ImageLab")} />
                        <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.OTSelected} onChange={(e) => { this.handleCheckBox(e, "OTSelected") }} size='small' />} label={t("OT")} /> */}
                        {/* <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.ImageLabSelected} onChange={(e) => { this.handleCheckBox(e, "ImageLabSelected") }} size='small' />} label={t("ImageLab")} />*/}
                        {this.props?.PageName === "CancelledBills" || this.props?.PageName === "SavedBills" || this.props.PageName === 'ReceiptBills' || !this.CheckMappedModule("OT") ? null : <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.OTSelected} onChange={(e) => { this.handleCheckBox(e, "OTSelected") }} size='small' />} label={t("OT")} />} 
                    </Box>
                </Box>}</>}

                { localGetItem("isNewBilling") === "true" ? <>  {this.props.labReceipt || this.props.Pharmacy || (!this.state.FilterDatas?.is_bill_wise && this.props.PageName === "CreditBills") || this.props.PageName === 'ReceiptBills' || (this.props.PageName === "DayEndStatus") || (this.props.PageName === 'LabDayEnd') ? null : 
                <Box component={"div"}>
                    <Box className="eMed_Filter_Header">
                        <Typography marginLeft={"1vw"}>{"Billed From"}</Typography>
                    </Box>  
                            <Box className="eMed_CheckBox_Group">
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.FilterDatas.frontOfficeCrBills} onChange={(e) => { this.handleCheckBox(e, "frontOfficeCrBills",) }} size='small' />} label={t("Front Office")} />
                                {this.CheckMappedModule("PHARMACY") && PharmacyList?.map((list, index) => (
                                    <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Pharmacy_Bills_In_FO") === "false"} checked={this.state.FilterDatas?.MultiPharmaIds?.includes(list?.pharmacy_id)} onChange={(e) => { this.handleCheckBox(e, "pharmaCreditBills", "multipharma", list?.pharmacy_id) }} size='small' />} label={PharmacyList?.length > 1 ? list?.pharmacy_name : t("Pharmacy")} />
                                ))
                                }
                                {this.CheckMappedModule("LAB") && LabList?.map((list, index) => (
                                    <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas?.MultiLabIds?.includes(list?.laboratory_id)} onChange={(e) => { this.handleCheckBox(e, "labCreditBills", "multilab", list?.laboratory_id) }} size='small' />} label={LabList?.length > 1 ? list?.laboratory_name : t("Laboratory")} />
                                ))}
                                {this.CheckMappedModule("RADIOLOGY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Radiology_Bills_In_FO") === "false"} checked={this.state.FilterDatas.radiologyCreditBills} onChange={(e) => { this.handleCheckBox(e, "radiologyCreditBills") }} size='small' />} label={t("Radiology")} /> : null}
                                {
                                    this.InvestigationList()?.length > 0 && <>
                                        {this.InvestigationList()?.map((list, index) => (
                                            <FormControlLabel key={index} className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas?.MultiInvestigations?.includes(list)} onChange={(e) => { this.handleCheckBox(e, "investigationCreditBills", "MultiInvestigations", list) }} size='small' />} label={list} />
                                        ))}
                                    </>

                                }
                                {(this.props?.PageName === "OverallBills" || this.props?.PageName === "CancelledBills" || this.props?.PageName === 'SavedBills') && this.CheckMappedModule("DOCTOR") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.doctorCreditBills} onChange={(e) => { this.handleCheckBox(e, "doctorCreditBills") }} size='small' />} label={t("Doctor")} /> : null}
                                {(this.props?.PageName === "CancelledBills" || this.props?.PageName === "SavedBills" || this.props.PageName === 'ReceiptBills' || localGetItem('isNewBilling') === "true" || !this.CheckMappedModule("OT")) ? null : <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.otCreditBills} onChange={(e) => { this.handleCheckBox(e, "otCreditBills") }} size='small' />} label={t("OT")} />}
                            </Box>
                </Box>}</> 
                : <>{this.props.labReceipt || this.props.Pharmacy || (!this.state.FilterDatas?.is_bill_wise && this.props.PageName === "CreditBills") || this.props.PageName === 'ReceiptBills' || (this.props.PageName === "DayEndStatus") || (this.props.PageName === 'LabDayEnd') ? null : 
                <Box component={"div"}>
                    <Box className="eMed_Filter_Header">
                        <Typography marginLeft={"1vw"}>{t("Bills")}</Typography>
                    </Box>
                    <Box className="eMed_CheckBox_Group">
                        <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.FilterDatas.ipCreditBills} onChange={(e) => { this.handleCheckBox(e, "ipCreditBills",) }} size='small' />} label={t("InPatient")} />
                        <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.opCreditBills} onChange={(e) => { this.handleCheckBox(e, "opCreditBills") }} size='small' />} label={t("OutPatient")} />
                                {/* <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Pharmacy_Bills_In_FO") === "false"} checked={this.state.FilterDatas.pharmaCreditBills} onChange={(e) => { this.handleCheckBox(e, "pharmaCreditBills") }} size='small' />} label={t("Pharmacy")} /> */}
                                
                                {this.CheckMappedModule("PHARMACY") && PharmacyList?.map((list, index) => (
                                    <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Pharmacy_Bills_In_FO") === "false"} checked={this.state.FilterDatas?.MultiPharmaIds?.includes(list?.pharmacy_id)} onChange={(e) => { this.handleCheckBox(e, "pharmaCreditBills", "multipharma", list?.pharmacy_id) }} size='small' />} label={PharmacyList?.length > 1 ? list?.pharmacy_name : t("Pharmacy")} />
                                ))
                                }

                                {this.CheckMappedModule("LAB") && LabList?.map((list, index) => (
                                    <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas?.MultiLabIds?.includes(list?.laboratory_id)} onChange={(e) => { this.handleCheckBox(e, "labCreditBills", "multilab", list?.laboratory_id) }} size='small' />} label={LabList?.length > 1 ? list?.laboratory_name : t("Laboratory")} />
                                ))
                                }
                        {this.CheckMappedModule("RADIOLOGY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Radiology_Bills_In_FO") === "false"}  checked={this.state.FilterDatas.radiologyCreditBills} onChange={(e) => { this.handleCheckBox(e, "radiologyCreditBills") }} size='small' />} label={t("Radiology")} /> : null}
                        {this.CheckMappedModule("SCOPY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Radiology_Bills_In_FO") === "false"}  checked={this.state.FilterDatas.radiologyCreditBills} onChange={(e) => { this.handleCheckBox(e, "radiologyCreditBills") }} size='small' />} label={t("Scopy")} /> : null}
                        {this.CheckMappedModule("AUDIOMETRY") ? <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Radiology_Bills_In_FO") === "false"}  checked={this.state.FilterDatas.radiologyCreditBills} onChange={(e) => { this.handleCheckBox(e, "radiologyCreditBills") }} size='small' />} label={t("Audiometry")} /> : null}
                        {this.props?.PageName === "CancelledBills" || this.props?.PageName === "SavedBills" || this.props.PageName === 'ReceiptBills' || !this.CheckMappedModule("OT") ? null : <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.otCreditBills} onChange={(e) => { this.handleCheckBox(e, "otCreditBills") }} size='small' />} label={t("OT")} />}
                    </Box>
                </Box>}</>}
                    {localGetItem('isNewBilling') === 'false' ? (this.props.labReceipt || (this.props.Pharmacy && this.props.PageName === 'ReceiptBills') )?
                        <Box component={'div'} marginTop={"0.5vw"}>
                            <Box className="eMed_CheckBox_Group">
                                <FormControlLabel sx={{fontSize:"0.8vw"}} control={<Checkbox checked={this.state.FilterDatas.includeFObills} onChange={(e) => { this.handleCheckBox(e, "includeFObills") }} size='small' />} label={`Include ${this.props.labReceipt ? "Lab" : "Pharmacy"} Receipts from FO`} />
                            </Box>
                        </Box> : null : null
                }
                {this.props.PageName === 'ReceiptBills' ? 
                 <Box component={"div"}>
                    <Box className="eMed_Filter_Header">
                        <Typography marginLeft={"1vw"}>{t("Receipt For") }</Typography>
                    </Box>
                    <Box className="eMed_CheckBox_Group">
                    <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.BillReceiptSelected} disabled={(this.state.FilterDatas.returnFrom && this.state.FilterDatas.returnTo ) || (this.state.FilterDatas.ReceiptFrom && this.state.FilterDatas.ReceiptTo) ? true : false} onChange={(e) => { this.handleCheckBox(e, "BillReceiptSelected") }} size='small' />} label={t("Bill")} />
                    { this.props.fromLab || this.props.Pharmacy ? null:
                     <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.AdvanceTypeSelected} onChange={(e) => { this.handleCheckBox(e, "AdvanceTypeSelected") }} size='small' />} label={t("Advance")} /> }
                    { this.props.fromLab || this.props.Pharmacy ? null:
                     <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.AdvanceRefundTypeSelected} onChange={(e) => { this.handleCheckBox(e, "AdvanceRefundTypeSelected") }} size='small' />} label={t("Advance Refund")} /> }
                    <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.RefundTypeSelected} disabled={(this.state.FilterDatas.ReceiptFrom && this.state.FilterDatas.ReceiptTo ) || (this.state.FilterDatas.returnFrom && this.state.FilterDatas.returnTo) ? true : false} onChange={(e) => { this.handleCheckBox(e, "RefundTypeSelected") }} size='small' />} label={t("Refund")} />
                    {this.props.Pharmacy ? null : <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.CancelledTypeSelected} onChange={(e) => { this.handleCheckBox(e, "CancelledTypeSelected") }} size='small' />} label={t("Cancelled")} /> }
                    {(this.props.Pharmacy || localGetItem("isNewBilling") !== "true") ? null : <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.MembershipTypeSelected} onChange={(e) => { this.handleCheckBox(e, "MembershipTypeSelected") }} size='small' />} label={t("Membership")} /> }
                    {(this.props.Pharmacy || (localGetItem("enable_safety_deposit") !== "true" || localGetItem("safety_deposit_permission") !== "true")) ? null : <FormControlLabel sx={{ width: "11vw"}} control={<Checkbox checked={this.state.FilterDatas.SDTypeSelected} onChange={(e) => { this.handleCheckBox(e, "SDTypeSelected") }} size='small' />} label={t("Safety Desposit")} /> }
                    {(this.props.Pharmacy || (localGetItem("enable_safety_deposit") !== "true" || localGetItem("safety_deposit_permission") !== "true")) ? null : <FormControlLabel sx={{ width: "14vw"}} control={<Checkbox checked={this.state.FilterDatas.SDRefundTypeSelected} onChange={(e) => { this.handleCheckBox(e, "SDRefundTypeSelected") }} size='small' />} label={t("Safety Desposit Refund")} /> }
                    </Box>
                 </Box>
                : null}
                    {this.props.PageName === 'ReceiptBills' ?
                        <Box component={'div'}>
                            <Box className="eMed_Filter_Header">
                                <Typography marginLeft={"1vw"}>{t("Against Credit")}</Typography>
                            </Box>
                            <Box component={'div'} className="eMed_CheckBox_Group">
                                <RadioGroup
                                    value={this.state.FilterDatas.AgainstCredit}
                                    sx={{ display: 'flex', flexDirection: 'row' }}
                                    onChange={(e) => {
                                        this.state.FilterDatas.AgainstCredit = e.target.value
                                        this.setState({ FilterDatas: this.state.FilterDatas })
                                    }}
                                >
                                    <FormControlLabel value={'true'} control={<Radio size='small' disabled={!this.state.FilterDatas.BillReceiptSelected} />} label="Yes" />
                                    <FormControlLabel value={'false'} control={<Radio size='small' disabled={!this.state.FilterDatas.BillReceiptSelected}/>} label="No" />
                                    <FormControlLabel value={'both'} control={<Radio size='small' disabled={!this.state.FilterDatas.BillReceiptSelected} />} label="Both" />
                                </RadioGroup>
                            </Box>
                        </Box> : null}
                    {this.props.PageName === 'OverallBills' && this.props.Pharmacy && LoggedData?.show_pharmacy_sales_token ?
                        <Box component={"div"} marginLeft={"1vw"}>
                            <FormControlLabel className='' control={<Checkbox checked={this.state.FilterDatas.tokenNumber} onChange={(e) => {
                                this.state.FilterDatas.tokenNumber = e.target.checked
                                this.setState({ FilterDatas: this.state.FilterDatas })
                            }} disabled = {(this.state.FilterDatas.is_by_bill_no && this.props.pharmacy)} size='small' />} label={t("Only Token Number")} />
                        </Box> : null
                    }
                {
                    ((this.props.PageName === "OverallBills") && !this.props.Pharmacy) ?
                        <Box component={"div"}>
                            <Box className="eMed_Filter_Header">
                                <Typography marginLeft={"1vw"} >Bill Type</Typography>
                            </Box>
                            <Box className="eMed_CheckBox_Group">
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.CompletedSelected} onChange={(e) => { this.handleCheckBox(e, "CompletedSelected") }} size='small' />} label={t("Completed")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.CreditSelected} onChange={(e) => { this.handleCheckBox(e, "CreditSelected") }} size='small' />} label={t("Credit")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.ReturnSelected} onChange={(e) => { this.handleCheckBox(e, "ReturnSelected") }} size='small' />} label={t("Return")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.CancelledSelected} onChange={(e) => { this.handleCheckBox(e, "CancelledSelected") }} size='small' />} label={t("Cancelled")} />
                            </Box>
                        </Box> : null
                }

                {
                    ((this.props.PageName === "ReceiptBills") || (this.props.PageName === "DayEndStatus") || (this.props.PageName === "LabDayEnd")) ?
                        <Box component={"div"}>
                            <Box className="eMed_Filter_Header">
                                <Typography marginLeft={"1vw"} >Payment Method</Typography>
                            </Box>
                            <Box className="eMed_CheckBox_Group">
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.CashSelected} onChange={(e) => { this.handleCheckBox(e, "CashSelected") }} size='small' />} label={t("Cash")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.CardSelected} onChange={(e) => { this.handleCheckBox(e, "CardSelected") }} size='small' />} label={t("Card")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.UPISelected} onChange={(e) => { this.handleCheckBox(e, "UPISelected") }} size='small' />} label={t("UPI")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.BankTransferSelected} onChange={(e) => { this.handleCheckBox(e, "BankTransferSelected") }} size='small' />} label={t("BankTransfer")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.ChequeSelected} onChange={(e) => { this.handleCheckBox(e, "ChequeSelected") }} size='small' />} label={t("Cheque")} />
                                {/* {this.props.Pharmacy ? null :<FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.InsuranceSelected} onChange={(e) => { this.handleCheckBox(e, "InsuranceSelected") }} size='small' />} label={t("Insurance")} />} */}
                                {this.props.fromReceipt ? 
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled = {this.state.FilterDatas.PayMethods?.length >= 2 ? false : true} checked={this.state.FilterDatas.combined} onChange={(e) => { this.handleCheckBox(e, "combined") }} size='small' />} label={t("Combined")} /> : null}
                                
                            </Box>
                        </Box> : null
                }

                {
                    ((this.props.PageName === "CreditBills")) ?
                        <Box component={"div"}>
                            <Box className="eMed_Filter_Header">
                                <Typography marginLeft={"1vw"} >Credit Type</Typography>
                            </Box>
                            <Box className="eMed_CheckBox_Group">
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.CorporateCredit} onChange={(e) => { this.handleCheckBox(e, "CorporateCredit") }} size='small' />} label={t("Corporate")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.Insurance} onChange={(e) => { this.handleCheckBox(e, "Insurance") }} size='small' />} label={t("Insurance")} />
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.PatientCredit} onChange={(e) => { this.handleCheckBox(e, "PatientCredit") }} size='small' />} label={t("Patient")} />
                            </Box>
                            {(!this.state.FilterDatas.CorporateCredit && this.state.FilterDatas.Insurance && !this.state.FilterDatas?.PatientCredit) ? 
                                <Autocomplete
                                    multiple
                                    limitTags={1}
                                    size='small'
                                    id="combo-box-demo-ins"
                                    options={this.state.FilterDatas?.insuranceData}
                                    getOptionLabel={(options) => typeof (options) === 'string' ? options : options.insurance_name}
                                    onChange={(e, value) => {
                                        this.setState((prev) => ({
                                        FilterDatas: {
                                            ...prev.FilterDatas,
                                            insuranceName: value,
                                            corporateName: [],
                                        },
                                        }));
                                    }}
                                    value={this.state.FilterDatas?.insuranceName}
                                    sx={{ width: '20vw', marginLeft: '1vw' }}
                                    renderInput={(params) => <TextField {...params} label="Insurance Company Name" />}
                                />
                            : (this.state.FilterDatas.CorporateCredit && !this.state.FilterDatas.Insurance && !this.state.FilterDatas?.PatientCredit) ? 
                            <Autocomplete
                                multiple
                                limitTags={1}
                                size='small'
                                id="combo-box-demo-corp"
                                options={this.state.FilterDatas?.corporateData}
                                getOptionLabel={(options) => typeof (options) === 'string' ? options : options.company_name}
                                onChange={(e, value) => {
                                        this.setState((prev) => ({
                                        FilterDatas: {
                                            ...prev.FilterDatas,
                                            insuranceName: [],
                                            corporateName: value,
                                        },
                                        }));
                                }}
                                value={this.state.FilterDatas?.corporateName}
                                sx={{ width: '20vw', marginLeft: '1vw' }}
                                renderInput={(params) => <TextField {...params} label="Corporate Company Name" />}
                            />
                            : null}
                        </Box> : null
                }
                {this.props.Pharmacy && this.props.PageName === 'OverallBills' ?
                    <Box component={'div'}>
                        <Box className="eMed_Filter_Header">
                                <Typography marginLeft={"1vw"} >Bill Type</Typography>
                            </Box>
                        <Box className="eMed_CheckBox_Group">
                            <FormControlLabel disabled = {(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy)} className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.credit} onChange={(e) => { this.handleCheckBox(e, "credit") }} size='small' />} label={t("Credit")} />
                            <FormControlLabel disabled = {(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy)} className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.completed} onChange={(e) => { this.handleCheckBox(e, "completed") }} size='small' />} label={t("Completed")} />
                            <FormControlLabel disabled = {(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy)} className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.FilterDatas.return} onChange={(e) => { this.handleCheckBox(e, "return") }} size='small' />} label={t("Return")} />
                        </Box>
                    </Box> : null
                }
                {this.props.PageName === 'OverallBills' || this.props.Pharmacy && this.props.PageName === 'OverallBills' ?
                    <Box component={"div"}>
                        <Box className="eMed_Filter_Header">
                            <Typography marginLeft={"1vw"}>Payment Status</Typography>
                        </Box>
                        <Box className="eMed_CheckBox_Group">
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled = {(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy)} checked={this.state.FilterDatas.selectedPaid} onChange={(e) => { this.handleCheckBox(e, "selectedPaid") }} size='small' />} label={t("Paid")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled = {(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy)} checked={this.state.FilterDatas.selectedNotPaid} onChange={(e) => { this.handleCheckBox(e, "selectedNotPaid") }} size='small' />} label={t("Not Paid")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled = {(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy)} checked={this.state.FilterDatas.selectedPartial} onChange={(e) => { this.handleCheckBox(e, "selectedPartial") }} size='small' />} label={t("Partial")} />
                        </Box>
                    </Box> : null
                }
                {this.props.Pharmacy && this.props.PageName === 'OverallBills' ?
                    <Box component={'div'}>
                        <Box className="eMed_Filter_Header">
                                <Typography marginLeft={"1vw"} >Delivery Type</Typography>
                            </Box>
                        <Box className="eMed_CheckBox_Group">
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled = {(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy)} checked={this.state.FilterDatas.typeInhouse} onChange={(e) => { this.handleCheckBox(e, "typeInhouse") }} size='small' />} label={t("InHouse")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled = {(this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy)} checked={this.state.FilterDatas.typeDoorDelivery} onChange={(e) => { this.handleCheckBox(e, "typeDoorDelivery") }} size='small' />} label={t("Door Delivery")} />
                        </Box>
                    </Box> : null
                }
               </Box>
                <Box component={"div"} className="eMed_Filter_Btn_Div">
                    <Button size="small" className='eMed_Filter_Btns' emed_tid={`${this.props.PageName}_Filter_Clear_Btn`} disabled={this.state.disableBtn} onClick={() => { this.ClearFilterData() }} variant='outlined'>{t("Clear")}</Button>
                    <Button size="small" className='eMed_Filter_Btns' emed_tid={`${this.props.PageName}_Filter_Clear_Btn`}
                        disabled={(this.props.PageName === 'OverallBills' && this.state.FilterDatas.is_by_bill_no && this.props.Pharmacy && !this.state.FilterDatas.overall_bill_no) ? true :
                            this.state.disableBtn ? true : ((this.state.FilterDatas?.startTime !== null && this.state.FilterDatas?.endTime === null) ||
                                (this.state.FilterDatas?.startTime !== null && this.state.error)) ? true : this.disableSearchBtn()}
                        onClick={() => { this.FilterSearch() }} variant='contained'>{t("Search")}</Button>
                    {this.props.PageName === "DayEndStatus" ?
                        <Button size="small" className='eMed_Filter_Btns' onClick={() => { this.PrintDetails() }} variant='contained'>{t("Print")}</Button>
                        : null}
                </Box>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}

            </Box>
        )
    }
}

export default withTranslation()(BillingsFilter)


